// Este codigo fue generado por Github Copilot Chat
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { Pagination } from '../../helpers/pagination.model';
import { SelectOption } from '../select/options.type';
import { SelectComponent } from '../select/select.component';
import { HandleFormControlPipe } from '../../pipes/handle-form-control.pipe';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectComponent,
    HandleFormControlPipe
  ],
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnChanges, OnInit {
  @Input() option = 10;

  formPagination = new FormGroup({
    size: new FormControl<number>(this.option)
  });

  pagination: Pagination = { page: 0, pageSize: this.option, total: 0 };
  availableButtons: number[] = [];
  showLastButtonOption = false;

  @Input() pageSizes: SelectOption<number>[] = [
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '50', value: 50 }
  ];

  @Input() totalRegister = 0;

  @Output() getData = new EventEmitter<Pagination>();

  ngOnInit(): void {
    // Sync pagination with input option value
    this.pagination.pageSize = this.option;
    this.formPagination.get('size')?.setValue(this.option);
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['totalRegister'] &&
      changes['totalRegister'].currentValue !==
        changes['totalRegister'].previousValue
    ) {
      this.calculatePagination();
    }
  }

  updatePageSize(val: number | string) {
    const numericVal = typeof val === 'string' ? Number.parseInt(val, 10) : val;
    this.option = numericVal;
    this.pagination.pageSize = this.option;
    this.pagination.page = 0; // Reset to first page when changing size
    this.calculatePagination();
    this.getAll();
  }

  initData = () => {
    this.getAll();
  };

  nextPage() {
    if (this.pagination.page < this.pagination.total - 1) {
      this.pagination.page++;
      this.getAll();
    }
    this.calculatePaginationButtons();
  }

  previousPage() {
    if (this.pagination.page > 0) {
      this.pagination.page--;
      this.getAll();
    }
    this.calculatePaginationButtons();
  }

  specificPage(page: number) {
    if (page >= 0 && page <= this.pagination.total) {
      this.pagination.page = page;
      this.getAll();
    }
    this.calculatePaginationButtons();
  }

  getAll(): void {
    this.getData.emit(this.pagination);
  }

  private calculatePagination() {
    this.pagination.total = Math.ceil(
      this.totalRegister / this.pagination.pageSize
    );
    this.calculatePaginationButtons();
  }

  private calculatePaginationButtons() {
    this.availableButtons = [this.pagination.page];
    this.setButtonsBehind();
    this.setButtonsAhead();
    this.showLastButtonOption =
      (this.availableButtons.at(-1) ?? 0) < this.pagination.total - 1;
  }

  setButtonsAhead() {
    let maxNumber = this.pagination.total - this.pagination.page - 1;
    if (this.pagination.page === 0) maxNumber = Math.min(maxNumber, 4);

    if (this.pagination.page === 1) maxNumber = Math.min(maxNumber, 3);

    if (this.pagination.page >= 2) maxNumber = Math.min(maxNumber, 2);

    for (let a = 0; a < maxNumber; a++) {
      this.availableButtons.push(this.pagination.page + a + 1);
    }
  }

  setButtonsBehind() {
    let minusNumber: number;
    if (this.pagination.page + 1 === this.pagination.total) {
      minusNumber = 4;
    } else if (this.pagination.page + 1 === this.pagination.total - 1) {
      minusNumber = 3;
    } else {
      minusNumber = 2;
    }
    let i = this.pagination.page;
    do {
      if (i > 0) this.availableButtons.unshift(i - 1);
      i--;
      minusNumber--;
    } while (i > 0 && minusNumber > 0);
  }
}
// Este codigo fue generado por Github Copilot Chat
